const resolveCssVariable = (name: string, asNumber = false): string | number =>  {
    const val = window.getComputedStyle(document.documentElement).getPropertyValue(name)

    if (asNumber && val) return parseInt(val, 10) as number

    return val
}

export default resolveCssVariable
